<template>
  <div class="dialog-container">
    <!-- 填写发票信息 -->
    <el-dialog v-model="isDialog" width="800px" center :before-close="handleClose" top="5vh" title="填写发票信息">
      <div style="display: grid; justify-items: center; padding: 0" id="invoiceDialog">
        <!-- <div class="invoice-header">
          <div class="header-icon"></div>
          <span>申请发票</span>
        </div> -->
        <el-form class="formDiv" v-model="invoiceForm" :rules="invoiceRules" ref="invoiceFrom" label-width="120px">
          <div
            id="radioGroupId"
            :class="{
              'radio-block': invoiceForm.invoiceContent == 2 && invoiceForm.invoiceTitleType == 1,
              block: invoiceForm.invoiceContent == 1 && invoiceForm.invoiceTitleType == 1
            }"
          >
            <el-form-item label="发票类型" prop="invoiceType">
              <el-radio-group v-model="invoiceForm.invoiceType">
                <el-radio :label="1" style="margin: 0 108px 0 50px">增值税专用发票</el-radio>
                <el-radio :label="2">普通发票</el-radio>
                <!-- <el-radio :label="3">电子普票</el-radio> -->
              </el-radio-group>
            </el-form-item>
            <el-form-item label="发票内容" prop="invoiceContent">
              <el-radio-group v-model="invoiceForm.invoiceContent">
                <el-radio :label="1" style="margin: 0 150px 0 50px">商品明细</el-radio>
                <el-radio :label="2">商品类别</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="content-msg-item" v-if="invoiceForm.invoiceContent == 2">
              <span class="content-msg">
                发票内容将显示本商品所属类别（信息技术服务或软件）及价格信息，<br />
                发票金额以实际支付金额，不含虚拟资产、优惠等扣减金额。
              </span>
            </el-form-item>
            <el-form-item label="抬头类型" prop="invoiceTitleType">
              <el-radio-group v-model="invoiceForm.invoiceTitleType">
                <el-radio :label="1" style="margin: 0 150px 0 50px">单位&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </el-radio>
                <el-radio :label="2">个人</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div v-if="invoiceForm.invoiceTitleType == 1">
            <div class="invoice-base">
              <div class="header">
                <!-- <div class="header-icon"></div> -->
                <span>发票基本信息</span>
              </div>

              <div style="height: 50px; display: grid; grid-template-columns: repeat(2, 1fr); grid-template-rows: 1fr; align-items: center">
                <el-form-item label="抬头名称" prop="title" key="title">
                  <el-input v-model="invoiceForm.title" placeholder="请输入抬头名称" maxlength="32" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="单位税号" prop="taxNumber" key="code">
                  <el-input v-model="invoiceForm.taxNumber" placeholder="请输入单位税号"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="company-base">
              <div class="header">
                <!-- <div class="header-icon"></div> -->
                <span>企业基本信息</span>
              </div>
              <div style="display: grid; grid-template-columns: repeat(2, 1fr); grid-template-rows: repeat(2, 1fr); align-items: center">
                <el-form-item
                  label="注册地址"
                  prop="companyRegisterAddress"
                  :rules="invoiceForm.invoiceType === 1 ? invoiceRules.companyRegisterAddress : [{ required: false }]"
                >
                  <el-input v-model="invoiceForm.companyRegisterAddress" placeholder="请输入注册地址"> </el-input>
                </el-form-item>
                <el-form-item
                  label="注册电话"
                  prop="companyRegisterPhone"
                  :rules="invoiceForm.invoiceType === 1 ? invoiceRules.companyRegisterPhone : [{ required: false }]"
                >
                  <el-input v-model="invoiceForm.companyRegisterPhone" placeholder="请输入注册电话"></el-input>
                </el-form-item>
                <el-form-item label="开户银行" prop="bank" :rules="invoiceForm.invoiceType === 1 ? invoiceRules.bank : [{ required: false }]">
                  <el-input v-model="invoiceForm.bank" placeholder="请输入开户银行"></el-input>
                </el-form-item>
                <el-form-item
                  label="银行账号"
                  prop="bankAccount"
                  :rules="invoiceForm.invoiceType === 1 ? invoiceRules.bankAccount : [{ required: false }]"
                >
                  <el-input v-model="invoiceForm.bankAccount" placeholder="请输入银行账号"></el-input>
                </el-form-item>
              </div>
            </div>
            <div v-if="invoiceForm.invoiceType == 3" class="email-address">
              <div class="header">
                <div class="header-icon"></div>
                <span>邮箱信息</span>
              </div>

              <el-form-item label="接收邮箱" prop="emailAddress">
                <el-input v-model="invoiceForm.emailAddress" placeholder="请输入接收邮箱地址"></el-input>
              </el-form-item>
            </div>
            <div v-if="invoiceForm.invoiceType !== 3" class="post-address">
              <div class="header">
                <!-- <div class="header-icon"></div> -->
                <span>邮寄地址</span>
              </div>
              <div style="display: grid; grid-template-columns: repeat(2, 1fr); grid-template-rows: 1fr; align-items: center">
                <el-form-item label="收货人" prop="receiver">
                  <el-input v-model="invoiceForm.receiver" placeholder="请输入收货人"></el-input>
                </el-form-item>
                <el-form-item label="手机号码" prop="phone">
                  <el-input v-model="invoiceForm.phone" placeholder="请输入手机号码"></el-input>
                </el-form-item>
                <el-form-item label="详细地址" prop="postAddress">
                  <el-input v-model="invoiceForm.postAddress" placeholder="请输入详细地址"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="header">
              <span>备注</span>
            </div>

            <el-form-item label="备注" prop="comment">
              <el-input
                v-model="invoiceForm.comment"
                placeholder="请输入备注"
                maxlength="60"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                show-word-limit
              ></el-input>
            </el-form-item>
          </div>
          <div v-if="invoiceForm.invoiceTitleType == 2" style="width: 640px">
            <div class="header">
              <div class="header-icon"></div>
              <span>发票基本信息</span>
            </div>
            <el-form-item label="抬头名称" prop="title" key="title1">
              <el-input v-model="invoiceForm.title" placeholder="请输入抬头名称" maxlength="32"></el-input>
            </el-form-item>

            <div v-if="invoiceForm.invoiceType !== 3">
              <div class="header">
                <div class="header-icon"></div>
                <span>邮寄地址</span>
              </div>
              <el-form-item label="收货人" prop="receiver">
                <el-input v-model="invoiceForm.receiver" placeholder="请输入收货人"></el-input>
              </el-form-item>
              <el-form-item label="手机号码" prop="phone">
                <el-input v-model="invoiceForm.phone" placeholder="请输入手机号码"></el-input>
              </el-form-item>
              <el-form-item label="详细地址" prop="postAddress">
                <el-input v-model="invoiceForm.postAddress" placeholder="请输入详细地址"></el-input>
              </el-form-item>
            </div>
            <div v-if="invoiceForm.invoiceType === 3">
              <div class="header">
                <div class="header-icon"></div>
                <span>邮箱信息</span>
              </div>
              <el-form-item label="接收邮箱" prop="emailAddress">
                <el-input v-model="invoiceForm.emailAddress" placeholder="请输入接收邮箱地址"></el-input>
              </el-form-item>
            </div>
            <div class="header">
              <div class="header-icon"></div>
              <span>备注</span>
            </div>
            <el-form-item label="备注" prop="comment">
              <el-input
                v-model="invoiceForm.comment"
                placeholder="请输入备注"
                maxlength="60"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                show-word-limit
              ></el-input>
            </el-form-item>
          </div>
          <!-- 
          <el-form-item>
            <el-button @click="submitForm()" class="btn-apply">申请发票</el-button>
          </el-form-item> -->
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="submitForm()" class="btn-apply">申请发票</el-button>
      </span>
    </el-dialog>
    <!--  申请-->
    <el-dialog v-model="applyDialog" width="503px">
      <div class="result">
        <p>
          <svg-icon icon-class="wait" size="100"></svg-icon>
        </p>
        <p>发票将在申请通过后的48小时内开具，请耐心等待</p>
      </div>
      <el-button @click="onCheckInvoice()" class="btn-check">查看申请记录</el-button>
    </el-dialog>

    <!-- 查看申请记录 -->
    <el-dialog v-model="isCheckDialog" center width="600px" :before-close="handleClose" @open="onCheckInvoice()" top="5vh" title="查看发票信息">
      <div class="invoice-header">
        <div class="header-icon"></div>
        <span style="font-size: 14px">发票信息</span>
      </div>
      <div class="record-header" v-if="query1.invoiceApplyStatus == 1 && query1.invoiceStatus == 0">
        <div class="record-title">
          <svg-icon iconClass="correct" />
          <span>已申请发票，等待财务进行开票审核...</span>
          <!-- <span v-else-if="
            query1.invoiceApplyStatus == 1 && query1.invoiceStatus == 1
          ">已完成</span> -->
        </div>
        <div class="invoice-total">
          <p class="total">开票金额</p>
          <span>{{ query1.issueInvoice.invoiceAmount ? `¥${query1.issueInvoice.invoiceAmount / 100}` : `¥${query1.totalAmount / 100}` }}</span>
        </div>
      </div>
      <!-- <p class="invoice-type">
        <span v-if="query1.invoiceApply.invoiceType == 1">增值税纸质专票</span>
        <span v-else-if="query1.invoiceApply.invoiceType == 2">增值税纸质普通发票</span>
        <span v-else-if="query1.invoiceApply.invoiceType == 3">增值税电子普通发票</span>
      </p> -->
      <div class="menu-bottom">
        <div class="menu-left">
          <p>
            发票类型：&nbsp;&nbsp;
            <span v-if="query1.invoiceApply.invoiceType == 1">纸质专票</span>
            <span v-else-if="query1.invoiceApply.invoiceType == 2">纸质普票</span>
            <span v-else-if="query1.invoiceApply.invoiceType == 3">电子普票</span>
          </p>
          <p>
            发票内容：&nbsp;&nbsp;
            <span v-if="query1.invoiceApply.invoiceContent == 1">商品明细</span>
            <span v-else-if="query1.invoiceApply.invoiceContent == 2">商品类别</span>
          </p>
          <p>
            抬头类型：&nbsp;&nbsp;
            <span v-if="query1.invoiceApply.invoiceTitleType == 1">单位</span>
            <span v-else-if="query1.invoiceApply.invoiceTitleType == 2">个人</span>
          </p>
          <p>
            开票金额：&nbsp;&nbsp;
            <span>{{ query1.issueInvoice.invoiceAmount ? `¥${query1.issueInvoice.invoiceAmount / 100}` : `¥${query1.totalAmount / 100}` }}</span>
          </p>
          <p v-if="query1.invoiceStatus == 1">
            开票时间：&nbsp;&nbsp;
            <span>{{ query1.issueInvoice && query1.issueInvoice.invoiceDate ? query1.issueInvoice.invoiceDate : "待处理" }} </span>
          </p>
          <p>
            申请时间：&nbsp;&nbsp; <span>{{ query1.invoiceApply.applyDate }}</span>
          </p>
          <div v-if="query1.invoiceApply.invoiceType !== 3 && query1.invoiceStatus === 1">
            <p>
              邮寄快递：&nbsp;&nbsp;
              <span>{{ query1.issueInvoice.expressName }}</span>
            </p>
            <p>
              快递单号：&nbsp;&nbsp;
              <span>{{ query1.issueInvoice.expressNumber }}</span>
            </p>
          </div>
        </div>
        <div class="menu-right" v-if="this.query1.invoiceApplyStatus == 1 && this.query1.invoiceStatus == 1">
          <el-image style="width: 100px; height: 100px" :src="query1.issueInvoice.invoiceVoucher" :preview-src-list="invoice"> </el-image>
          <span>点击预览发票</span>
          <!-- <el-button type="primary"> -->
          <!-- <a :href="query1.issueInvoice.invoiceVoucher" download="photo.png">下载</a> -->
          <!-- <a @click="downCom" >下载</a> -->
          <!-- <span v-down="query1.issueInvoice.invoiceVoucher">下载</span> -->
          <!-- </el-button> -->
        </div>
      </div>
      <div class="order-msg">
        <div class="header">
          <div class="header-icon"></div>
          <span>订单信息</span>
        </div>
        <div
          id="goodsScrollBox"
          style="
            display: flex;
            justify-content: space-between;
            margin: 10px 0 0 10px;
            padding: 10px;
            flex-wrap: wrap;
            max-height: 160px;
            overflow-y: auto;
            border: 1px solid #e4e6e8;
          "
        >
          <div class="order-block" v-for="(item, index) in query1.orderGoods" :key="index">
            <p><img :src="item.appIcon" alt /></p>
            <div class="info-wrapper">
              <span class="app-name">{{ item.appName }}</span>
              <!-- <span class="period-validity">有效期限:{{ item.applicationValidity
              }}{{
    constants.applicationValidityType[
    item.applicationValidityType
    ]
}}</span> -->
              <span class="auth-quantity">授权数量:{{ item.availableCount }}个</span>
            </div>
          </div>
        </div>
        <!-- <div class="menu-bottom"> <span>¥{{query1.totalAmount}}</span></div> -->
        <div class="gridBottom">
          <p>
            总金额：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span>{{ query1.issueInvoice.invoiceAmount ? `¥${query1.issueInvoice.invoiceAmount / 100}` : `¥${query1.totalAmount / 100}` }}</span>
          </p>
          <p>
            订单编号：&nbsp;&nbsp; <span>{{ query1.orderNumber }}</span>
          </p>
          <p>
            创建时间：&nbsp;&nbsp; <span>{{ query1.createDate }}</span>
          </p>
          <p>
            支付状态：&nbsp;&nbsp;
            <span v-if="query1.payState == 1" style="color: green">已支付</span>
            <span v-else>未支付</span>
          </p>
          <p>
            支付时间：&nbsp;&nbsp; <span>{{ query1.orderPay.payTime }}</span>
          </p>
        </div>
      </div>
      <!-- <div class="customer-block">
        <div class="header">
          <div class="header-icon"></div>
          <span>联系我们</span>
        </div>
        <div class="customer-service">
          <p>
            专属客服&nbsp;&nbsp;
            <span>{{ customerService.personName }}&nbsp;{{
                customerService.personPhone
            }}</span>
          </p>
        </div>
      </div> -->
    </el-dialog>
    <el-dialog custom-class="service-dialog" v-model="IsCallPhoneDialogVisible" width="500px" :show-close="false">
      <div class="reminder-msg">
        <p>请致电您的专属客服电话</p>
        <span>{{ customerService.personPhone }}</span>
      </div>
      <el-button class="btn-ok" @click="onCloseCallPhone()">好的</el-button>
    </el-dialog>
  </div>
</template>

<script>
import { applyInvoice, ordersDetail, customerService } from "@api/company.js";
import Vue from "vue";
import * as validator from "@/utils/validate.js";
import { mapState } from "vuex";
// Vue.directive("down", {
//   inserted: (el, binding) => {
//     el.style.cssText = "cursor: pointer;color:write;";
//     el.addEventListener("click", () => {
//       console.log(binding.value);
//       let link = document.createElement("a");
//       let url = baseDownloadUrl + binding.value;
//       // 这里是将url转成blob地址，
//       fetch(url)
//         .then((res) => res.blob())
//         .then((blob) => {
//           // 将链接地址字符内容转变成blob地址
//           link.href = URL.createObjectURL(blob);
//           console.log(link.href);
//           link.download = "";
//           document.body.appendChild(link);
//           link.click();
//         });
//     });
//   },
// });
export default {
  inject: ["reload"],
  computed: {
    ...mapState({
      constants: (state) => state.constants
    })
  },
  data() {
    return {
      invoiceTitleQuery: {
        companyMainUserAccountId: "16457702008944454699",
        isDefault: 1
      },
      // 申请发票
      applyDialog: false,
      // 查看申请记录
      // checkDialog: false,
      ownInvoice: 1,
      isDialog: this.dialog,
      isCheckDialog: this.checkDialog || false,
      IsCallPhoneDialogVisible: this.callPhoneDialogVisible || false,
      // 抬头类型
      headerType: 0,
      invoice: [],
      customerService: {
        personName: "",
        personPhone: ""
      },
      // 发票表单数据
      invoiceForm: {
        orderNumber: this.orderNumber,
        invoiceType: 1,
        invoiceTitleType: 1,
        invoiceContent: 1,
        title: "",
        taxNumber: "",
        companyRegisterAddress: "",
        bank: "",
        bankAccount: "",
        companyRegisterPhone: "",
        emailAddress: "",
        comment: "",
        receiver: "",
        postAddress: "",
        phone: ""
      },
      invoiceFormTwo: {
        orderNumber: this.orderNumber,
        invoiceType: 1,
        invoiceTitleType: 1,
        invoiceContent: 1,
        title: "",
        taxNumber: "",
        companyRegisterAddress: "",
        bank: "",
        bankAccount: "",
        companyRegisterPhone: "",
        emailAddress: "",
        comment: "",
        receiver: "",
        postAddress: "",
        phone: ""
      },
      // 发票规则
      invoiceRules: {
        invoiceType: [{ required: true }],
        invoiceContent: [{ required: true }],
        invoiceTitleType: [{ required: true }],
        title: [{ required: true, message: "请输入抬头名称", trigger: "blur" }],
        taxNumber: [
          { required: true, message: "请输入单位税号", trigger: "blur" },
          { validator: validator.checkCode, trigger: "blur" }
        ],
        companyRegisterAddress: [
          { required: true, message: "请输入注册地址", trigger: "blur" },
          { min: 1, max: 50, message: "最长50个字", trigger: "blur" }
        ],
        emailAddress: [
          { required: true, message: "请输入接收邮箱地址", trigger: "blur" },
          { validator: validator.validInvoiceEmail, trigger: "blur" }
        ],
        bankAccount: [
          { required: true, message: "请输入银行账号", trigger: "blur" },
          { validator: validator.checkInvoiceBankNo, trigger: "blur" }
        ],
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: validator.checkSalesPersonPhone, trigger: "blur" }
        ],
        companyRegisterPhone: [
          { required: true, message: "请输入注册电话", trigger: "blur" },
          {
            trigger: "blur",
            pattern: /^(?:(?:\d{3}-)?\d{8}|^(?:\d{4}-)?\d{7,8})(?:-\d+)?$|^(?:(?:\+|00)86)?1[3-9]\d{9}$/,
            message: "输入电话格式不合格"
          }
        ],
        receiver: [
          { required: true, message: "请输入收货人信息", trigger: "blur" },
          { min: 1, max: 20, message: "最长20个字", trigger: "blur" }
        ],
        postAddress: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
          { min: 1, max: 50, message: "最长50个字", trigger: "blur" }
        ],
        bank: [
          { required: true, message: "请输入开户银行", trigger: "blur" },
          { min: 1, max: 15, message: "最长15个字", trigger: "blur" }
        ],
        comment: [{ min: 1, max: 60, message: "最长60个字", trigger: "blur" }]
      },

      //
      query1: {
        orderNumber: "",
        payState: "",
        createDate: "",
        invoiceStatus: "",
        invoiceApplyStatus: "",
        totalAmount: "",
        orderInvoice: {},
        orderGoods: [
          {
            appIcon: "",
            appName: ""
          }
        ],
        orderPay: {
          payTime: ""
        },
        issueInvoice: {
          invoiceAmount: "",
          invoiceDate: "",
          expressName: "",
          expressNumber: "",
          expressVoucher: "",
          invoiceVoucher: ""
        },
        invoiceApply: [
          {
            invoiceType: "",
            invoiceContent: "",
            invoiceHead: "",
            invoiceTime: "",
            applyDate: ""
          }
        ]
      }
    };
  },
  props: ["dialog", "checkDialog", "orderNumber", "callPhoneDialogVisible", "companyMainUserAccountId"],
  watch: {
    dialog(val) {
      this.isDialog = val;
    },
    checkDialog(val) {
      this.isCheckDialog = val || false;
      customerService()
        .then((res) => {
          this.customerService = res.data;
        })
        .catch((res) => {
          console.log("catch ======>", res);
        });
    },
    callPhoneDialogVisible(val) {
      this.IsCallPhoneDialogVisible = val || false;
      customerService()
        .then((res) => {
          this.customerService = res.data;
        })
        .catch((res) => {
          console.log("catch ======>", res);
        });
    }
  },
  mounted() {},
  methods: {
    handleClose() {
      if (this.isDialog) {
        this.invoiceForm = { ...this.invoiceFormTwo };
        this.$refs["invoiceFrom"].clearValidate();
      }
      this.isDialog = false;
      this.$emit("update:dialog", false);
      this.$emit("closeInvoice");
      this.isCheckDialog = false;

      this.$emit("update:checkDialog", false);
    },
    onCloseCallPhone() {
      this.IsCallPhoneDialogVisible = false;
      this.$emit("update:callPhoneDialogVisible", false);
    },
    submitForm() {
      // 表单校验
      this.invoiceForm.orderNumber = this.orderNumber;
      this.$refs.invoiceFrom.validate((valid) => {
        if (valid) {
          applyInvoice(this.invoiceForm)
            .then((res) => {
              console.log(res);

              this.isDialog = false;
              this.reload();
              this.$emit("closeInvoice");
            })
            .catch((res) => {
              console.log("catch ======>", res);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //查看发票
    onCheckInvoice() {
      this.applyDialog = false;

      this.query1.orderNumber = this.orderNumber;
      ordersDetail(this.query1.orderNumber)
        .then((res) => {
          console.log(res);
          this.query1 = res.data;
          this.isCheckDialog = true;
          // this.query1.orderGoods = [...this.query1.orderGoods, ...this.query1.orderGoods, ...this.query1.orderGoods]
          if (res.data.issueInvoice) {
            this.invoice.push(res.data.issueInvoice.invoiceVoucher);
          } else {
            this.query1.issueInvoice = {};
          }
          // this.invoice.push(res.data.issueInvoice.invoiceVoucher);
          // console.log(this.query1.issueInvoice, 'aaaaaaaaa');
          // if (this.query1.issueInvoice.invoiceDate) {
          //   this.query1.issueInvoice.invoiceDate =
          //     this.query1.issueInvoice.invoiceDate.substring(0, 10);
          // }
        })
        .catch((res) => {
          console.log("catch ======>", res);
        });
    }
  }
};
</script>

<style lang="less" scoped>
::v-deep(.service-dialog) {
  .el-dialog__body {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
#goodsScrollBox::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  color: #ff6a00;
}

#goodsScrollBox::-webkit-scrollbar-track {
  border-radius: 5px;
}

#goodsScrollBox::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #ff6a00;
}

.dialog-container {
  ::v-deep(#radioGroupId) {
    .el-form-item {
      margin-bottom: 5px;
    }
  }

  // 选择发票类型
  .invoiceTitle {
    height: 40px;
    line-height: 40px;
    display: block;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
  }

  .msg {
    display: block;
    text-align: center;
    margin-top: 20px;
    font-size: 16px;
    font-weight: bold;
  }

  .invoiceType {
    margin-top: 40px;
    display: flex;
    justify-content: space-around;

    height: 60px;
    cursor: pointer;

    img {
      vertical-align: middle;
      margin-right: 10px;
    }

    .svg-icon {
      width: 50px;
      height: 30px;
      vertical-align: middle;
    }

    span {
      font-size: 22px;
      font-weight: bold;
      vertical-align: middle;
    }
  }

  // 申请
  .result {
    text-align: center;

    > p:last-child {
      margin-top: 30px;
      font-size: 24px;
      font-weight: bold;
    }

    .svg-icon {
      width: 409px;
      height: 312px;
      // vertical-align: middle;
    }
  }

  .btn-check {
    position: relative;
    bottom: 20px;
    width: 100px;
    background: #ff6a00;
    color: #fff;
    margin-top: 200px;
    margin-left: 210px;
  }

  // 填写发票表格样式
  .invoice-header {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #d2d2d2;

    .header-icon {
      width: 2px;
      height: 20px;
      background: #ff6a00;
      margin: 0 10px;
    }

    > span {
      padding-top: 4px;
      font-size: 16px;
      color: #4f4f4f;
    }
  }

  .header {
    width: 503px;
    margin: 10px 0;
    display: flex;
    align-items: center;

    > span {
      // padding-top: 4px;
      font-size: 16px;
      color: #4f4f4f;
      // font-weight: bold;
    }
  }

  .el-dialog__footer {
    .el-button {
      width: 140px;
      // margin-left: 70px;
      // margin-top: 26px;
      position: relative;
      bottom: 20px;
      border-radius: 4px;
      color: #fff;
      background: #ff6a00;
    }
  }

  .formDiv {
    margin-top: 10px;

    .radio-block {
      height: 180px;
    }

    .el-dialog__body {
      padding: 0;
    }

    .el-form-item__label {
      width: 100px;
      color: #a0a0a0;
      font-size: 12px;
    }

    .el-radio__label {
      color: #333333;
    }

    .el-radio__input.is-checked .el-radio__inner {
      border-color: #ff6a00;
      background: linear-gradient(180deg, #e2571a 0%, #fd8d2e 100%);
    }

    .el-radio__input.is-checked .el-radio__inner::after {
      content: "";
      width: 10px;
      height: 5px;
      border: 2px solid #fff;
      border-top: transparent;
      border-right: transparent;
      text-align: center;
      display: inline-block;
      position: absolute;
      top: 2px;
      left: 2px;
      vertical-align: middle;
      transform: rotate(-45deg);
      border-radius: 0px;
      background: none;
    }

    .content-msg {
      width: 382px;
      height: 30px;
      font-size: 12px;
      color: #a3a3a3;
    }

    > span {
      display: inline-block;
      margin-bottom: 18px;
      color: #000;
      font-weight: bold;
    }

    .notice {
      font-size: 14px;
      margin-top: 10px;
      margin-bottom: 10px;
      color: #a3a3a3;
    }
  }

  .el-dialog__title {
    font-size: 24px;
    font-weight: bold;
    position: relative;
    top: 20px;
  }

  // 发票记录
  .record-header {
    display: flex;
    justify-content: space-between;
    // width: 475px;
    flex: 1;
    height: 100px;
    border-radius: 7px;
    margin: 10px 14px;
    padding: 0 20px;
    background: #e2571a;
  }

  .record-title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: bold;

    // margin-right:238px;
    > span {
      color: #fff;
    }

    .svg-icon {
      width: 60px;
      height: 80px;
      // vertical-align: middle;
      margin-right: 10px;
    }
  }

  .invoice-total {
    margin-top: 10px;

    > p {
      font-size: 14px;
      margin-bottom: 5px;
      color: #fff;
    }

    > span {
      font-size: 22px;
      color: #fff;
    }
  }

  .main-title {
    margin-left: 20px;
    margin-top: 50px;

    > p {
      font-size: 20px;
      font-weight: bold;

      > span {
        font-size: 16px;
      }
    }
  }

  .order-msg {
    // height: 460px;
    border-top: 1px solid #e4e6e8;
    border-bottom: 1px solid #e4e6e8;
    margin-top: 10px;
    //  padding-bottom:20px;
  }

  .order-block {
    width: 235px;
    height: 52px;
    border: 0.6px solid #ebebeb;
    display: flex;
    align-items: center;
    margin-top: 20px;
    padding-left: 7.2px;

    .info-wrapper {
      flex-grow: 1;
      margin-left: 15px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;

      .app-name {
        font-size: 12px;
        color: #000;
      }

      .period-validity {
        font-size: 12px;
        color: #ffa668;
      }

      .auth-quantity {
        font-size: 12px;
        color: rgab(68, 68, 68, 0.6);
      }
    }

    .menu-middle {
      margin-left: 3px;
    }

    .menu-middle p:first-child {
      color: #171721;
      font-weight: bold;
      font-size: 9.6px;
      margin-top: 4px;
      margin-bottom: 8px;
    }

    .menu-middle p:nth-of-type(2) {
      color: #8083a3;
      font-size: 7.2px;
    }
  }

  .order-block img {
    vertical-align: middle;
    width: 29.4px;
    height: 29.4px;
  }

  .invoice-type {
    margin-top: 20px;
    font-size: 18px;
    color: #444444;
    text-align: center;
  }

  .total {
    margin-top: 20px;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }

  .menu-bottom {
    margin: 15px;
    display: flex;
    justify-content: space-between;

    p {
      height: 20px;
      line-height: 20px;
      color: #8083a3;
      font-size: 16px;
      margin-bottom: 5px;

      span {
        color: #171721;
        margin-left: 10px;
      }
    }
  }

  .gridBottom {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    // column-gap: 0px;
    row-gap: 5px;
    height: 100px;
    margin: 35px 0 0 15px;
  }

  .menu-right {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 20px;
  }

  .customer-service {
    margin-left: 20px;
    margin-top: 20px;
    height: 79px;
    margin-bottom: 10px;

    p {
      color: #8083a3;
      font-size: 14px;
      margin-bottom: 10px;

      span {
        color: #171721;
        margin-left: 20px;
      }
    }
  }

  .btn-exclusive {
    position: relative;
    bottom: 40px;
    margin-left: 700px;
    width: 160px;
    border-radius: 5px;
    font-size: 16px;

    .svg-icon {
      width: 30px;
      height: 30px;
      vertical-align: middle;
    }
  }

  .reminder-msg {
    text-align: center;
    padding-top: 40px;
    font-size: 24px;
    font-weight: bold;

    > span {
      display: inline-block;
      padding-top: 10px;
    }
  }

  .btn-ok {
    position: relative;
    width: 160px;
    height: 50px;
    font-size: 18px;
    background: #ff6a00;
    color: #fff;
    border-radius: 10px;
    margin-top: 20px;
    // margin-left: 170px;
    // margin-top: 80px;
    // bottom: 20px;
  }
}
</style>
